import { LeadStatusColor } from '@/shared'

export const enum TaskListType {
  Active = 'active',
  Due = 'due',
  Archive = 'archive',
  Deleted = 'deleted',
  AssignedToMe = 'assigned-to-me',
  CreatedByMe = 'created-by-me',
}

export const enum TaskTypeColorEnum {
  Default = 1,
  Danger = 2,
  Success = 3,
  Light = 4,
  Dark = 5,
}

export const enum TaskTypeIconEnum {
  Default = 1,
  Call = 2,
  SMS = 3,
  Email = 4,
  Messenger = 5,
  Status = 6,
  Business = 7,
  Data = 8,
  Child = 9,
}

export const enum TaskTypeStatusEnum {
  Danger = 3,
  Warning = 2,
  Success = 4,
  Default = 1,
}

export const enum TaskTypeStatusDefaultTitleEnum {
  NEW = 'new',
  DUE = 'due',
  COMPLETED = 'completed',
  DISMISSED = 'dismissed',
  DELETED = 'deleted',
}

export const TaskTypeIconMap = {
  [TaskTypeIconEnum.Default]: 'bell',
  [TaskTypeIconEnum.Call]: 'phone',
  [TaskTypeIconEnum.SMS]: 'sms',
  [TaskTypeIconEnum.Email]: 'email',
  [TaskTypeIconEnum.Messenger]: 'fbmessenger',
  [TaskTypeIconEnum.Status]: 'status',
  [TaskTypeIconEnum.Business]: 'business',
  [TaskTypeIconEnum.Data]: 'data',
  [TaskTypeIconEnum.Child]: 'child',
}

export const TaskTypeColorMap = {
  [TaskTypeColorEnum.Default]: LeadStatusColor.Orange,
  [TaskTypeColorEnum.Danger]: LeadStatusColor.Red,
  [TaskTypeColorEnum.Success]: LeadStatusColor.Green,
  [TaskTypeColorEnum.Light]: LeadStatusColor.Silver,
  [TaskTypeColorEnum.Dark]: LeadStatusColor.Gray,
}

export const TaskTypeBootstrapColorMap = {
  [TaskTypeColorEnum.Default]: 'warning',
  [TaskTypeColorEnum.Danger]: 'danger',
  [TaskTypeColorEnum.Success]: 'success',
  [TaskTypeColorEnum.Light]: 'muted',
  [TaskTypeColorEnum.Dark]: 'dark',
}

export const TaskTypeBgColorMap = {
  [TaskTypeColorEnum.Default]: 'warning',
  [TaskTypeColorEnum.Danger]: 'danger',
  [TaskTypeColorEnum.Success]: 'success',
  [TaskTypeColorEnum.Light]: 'muted',
  [TaskTypeColorEnum.Dark]: 'dark',
}

export const TaskTypeStatusTypeIconMap = {
  [TaskTypeStatusEnum.Danger]: 'close',
  [TaskTypeStatusEnum.Default]: 'check',
  [TaskTypeStatusEnum.Success]: 'check',
  [TaskTypeStatusEnum.Warning]: 'warning',
}

export const TaskFeatureEnum = {
  LMS: 'leads',
  EMS: 'candidates',
  Business: 'business',
}
